import React from "react";
import { ExternalLink } from "components/ExternalLink";
import {
  CopyableCodeLine,
  InlineCode,
} from "onboarding/components/NumberedStep";
import {
  APPOPTICS_INSTALLER_URL_BASE,
  KB_URL_BASE,
} from "onboarding/constants";
import { track } from "utils/track";

const SCRIPT = "appoptics-php.sh";
const SCRIPT_URL = `${APPOPTICS_INSTALLER_URL_BASE}/${SCRIPT}`;
const KNOWLEDGEBASE_URL = `${KB_URL_BASE}/apm_tracing/php/install/`;

const phpInstructions = props => {
  const { agentRecorderToken, serviceName } = props;
  return [
    {
      precedingContent: (
        <div>
          The install script below will manage downloading and configuring the
          agent. If you’d prefer to do this manually or need more help,{" "}
          <ExternalLink href={KNOWLEDGEBASE_URL}>
            check out our documentation
          </ExternalLink>.
        </div>
      ),
      title: "Download the install script:",
      content: (
        <div onClick={_ => track("Copied the PHP APM downloader script")}>
          <CopyableCodeLine shell>curl -sSO {SCRIPT_URL}</CopyableCodeLine>
        </div>
      ),
    },
    {
      title: (
        <span>
          Execute the script to download and install the required{" "}
          <InlineCode>.so</InlineCode> binary file:
        </span>
      ),
      content: (
        <div onClick={_ => track("Copied the PHP APM installer script")}>
          <CopyableCodeLine shell>
            sh {SCRIPT} --service-key={agentRecorderToken}:{serviceName}
          </CopyableCodeLine>
        </div>
      ),
    },
    {
      title: "Restart the service running PHP, e.g.:",
      content: (
        <div onClick={_ => track("Copied the PHP APM restart script")}>
          <CopyableCodeLine shell>
            sudo service apache2 restart
          </CopyableCodeLine>
          <p>
            A few seconds after you restart the PHP service, the agent will be
            connected to AppOptics.
          </p>
        </div>
      ),
    },
  ];
};

export default phpInstructions;
